import {Injectable} from '@angular/core';
import {Session} from './session';
import {SessionBehavior} from './session-behavior';

/**
 * Service for managing sessions
 */
@Injectable()
export class SessionService {

    /**
     * Creates a new session with simple behavior
     * @param endpoint The WebSocket endpoint
     * @param credentials Authentication credentials
     * @param credentialsSecret Authentication secret
     * @returns A new Session instance
     */
    public createSimpleSession(endpoint: string, credentials: string, credentialsSecret: string): Session {
        return new Session(endpoint, credentials, credentialsSecret, SessionBehavior.simple());
    }

    /**
     * Creates a new session with incremental behavior
     * @param endpoint The WebSocket endpoint
     * @param credentials Authentication credentials
     * @param credentialsSecret Authentication secret
     * @returns A new Session instance
     */
    public createIncrementalSession(endpoint: string, credentials: string, credentialsSecret: string): Session {
        return new Session(endpoint, credentials, credentialsSecret, SessionBehavior.incremental());
    }

    /**
     * Creates a new session with cyclical unified behavior
     * @param endpoint The WebSocket endpoint
     * @param credentials Authentication credentials
     * @param credentialsSecret Authentication secret
     * @returns A new Session instance
     */
    public createCyclicalUnifiedSession(endpoint: string, credentials: string, credentialsSecret: string): Session {
        return new Session(endpoint, credentials, credentialsSecret, SessionBehavior.cyclicalUnified());
    }

    /**
     * Creates a new session with cyclical delta behavior
     * @param endpoint The WebSocket endpoint
     * @param credentials Authentication credentials
     * @param credentialsSecret Authentication secret
     * @returns A new Session instance
     */
    public createCyclicalDeltaSession(endpoint: string, credentials: string, credentialsSecret: string): Session {
        return new Session(endpoint, credentials, credentialsSecret, SessionBehavior.cyclicalDelta());
    }
}
